module.exports = __webpack_public_path__ + "img/cash.90622ec8.svg";